import { ActionTree, MutationTree, GetterTree } from 'vuex';

import Module from '../interfaces/module.interface';
import { ModalState, TSubModal } from './modalTypes';
import { RootState } from '../types';
import uuidv4 from '@/utils/uuidv4';

export const state: ModalState = new ModalState([]);

const actions: ActionTree<ModalState, RootState> = {
  SET_SUB_MODAL(context, payload: ModalState) {
    context.commit('setSubModal', payload);
  },
  DESTROY_SUB_MODAL(context) {
    context.commit('destroySubModal');
  },
  CLEAR_ALL_SUB_MODALS(context) {
    context.commit('clearAllSubModals');
  }
};

const mutations: MutationTree<ModalState> = {
  setSubModal(state, payload: Omit<TSubModal, 'id'>) {
    state.submodals = [
      ...state.submodals,
      {
        id: uuidv4(),
        props: {},
        ...payload
      }
    ];
  },
  destroySubModal(state) {
    state.submodals.pop();
  },
  clearAllSubModals(state) {
    state.submodals = [];
  }
};

const getters: GetterTree<ModalState, RootState> = {
  getSubModals(state) {
    return state.submodals;
  }
};

const namespaced: boolean = true;

export const modal: Module<ModalState, RootState> = {
  namespaced,
  state,
  actions,
  mutations,
  getters
};
